module.exports = __webpack_public_path__ + "media/icon_transaction/cat_2-e60b51df.png";